




"use strict";

export default class EenmaligOnderhoudForm {

    constructor () {
        //this.setupSidebar();

        if ( document.querySelector('.show_total') ) {
            this.totalField = document.querySelectorAll('.show_total .total');
            this.totalItems = document.querySelectorAll('.show_total .total-items');
            this.totalHiddenField = document.querySelector('input[type="hidden"][data-show-total]');

            this.totalHiddenPostField = document.querySelector('.field-section.hidden.Totaal input[type="hidden"]');

            this.totalPrice = [];

            this.hideLoon = false;
            this.hideKetel = false;

            this.addEvents();
            this.updateTotal();
        }
    }


    updateTotal() {
        const arbeidElem = document.querySelector('.field-section.Arbeidslonen');
        if ( arbeidElem ) {
            if ( !this.hideLoon ) {
                arbeidElem.parentElement.classList.add('ylt-hidden');
            } else {
                arbeidElem.parentElement.classList.remove('ylt-hidden');
            }
        }

        const onderdeelElem = document.querySelector('.field-section.Onderdelen');
        if ( onderdeelElem ) {
            if ( !this.hideKetel ) {
                onderdeelElem.parentElement.classList.add('ylt-hidden');
            } else {
                onderdeelElem.parentElement.classList.remove('ylt-hidden');
            }
        }

        let showOnderdelen = false;

        this.totalItems.forEach(elem => {
            elem.innerHTML = '';
            this.totalPrice.forEach((item, index) => {

                if ( index == 1 && !this.hideLoon ) {
                    return;
                }

                if ( index == 1 && item.value != 0 ) {
                    showOnderdelen = true;
                }

                if ( index == 2 && (!this.hideKetel || !showOnderdelen ) ) {
                    return;
                }

                const dt = document.createElement('dt');
                dt.innerHTML = item.description == 'Geen' ? 'Extra\'s' : item.description;
                const dd = document.createElement('dd');
                dd.innerHTML = item.value.toFixed(2);

                elem.append(dt);
                elem.append(dd);
            });
        });

        const totalPrice = this.totalPrice.reduce((total, current) => total += current.value, 0).toFixed(2);
        this.totalField.forEach(field => {
            field.innerHTML = totalPrice;
        });

        if ( this.totalHiddenField ) {
            this.totalHiddenField.value = totalPrice;
        }

        if (  this.totalHiddenPostField ) {
            this.totalHiddenPostField.value = '€' + totalPrice;
        }
    }


    addEvents () {
        document.querySelectorAll('[data-add-to-total="true"] input')
            .forEach(elem => {
                const name = elem.name;
                let description = (elem.nextElementSibling) ? elem.nextElementSibling.innerHTML : name;
                if ( elem.classList.contains('gform_hidden') ) {
                    description = (elem.parentElement.nextElementSibling)
                                    ? elem.parentElement.nextElementSibling.innerHTML
                                    : name;
                }
                const value = parseFloat(elem.value);

                elem.addEventListener('change', () => {
                    if ( elem.checked ) {
                        if ( elem.type === 'radio' ) {
                            this.totalPrice = this.totalPrice.map(item => {
                                if ( item.name === name ) {
                                    return {value, description, name};
                                }
                                return item;
                            });
                        } else {
                            this.totalPrice.push({value, description, name});
                        }
                    } else {
                        this.totalPrice = this.totalPrice.filter(item => item.name !== name);
                    }
                    this.updateTotal();
                });

                if ( elem.checked || elem.type === 'hidden' ) {
                    this.totalPrice.push({value, description, name});
                    this.updateTotal();
                }
            });


        // Bouwjaar CV ketel
        const changeJaartalDropdown = (elem, select) => () => {
            elem.value = select.value;

            const option = select.querySelector(`[value="${select.value}"]`);

            const loonElems = document.querySelectorAll('.show_total.sidebar dt:nth-of-type(2), .show_total.sidebar dd:nth-of-type(2)');
            const ketelElems = document.querySelectorAll('.show_total.sidebar dt:nth-of-type(3), .show_total.sidebar dd:nth-of-type(3)');

            if ( option ) {
                if ( option.dataset.showKetel == "true" ) {
                    this.hideKetel = false;
                } else {
                    this.hideKetel = true;
                }

                if ( option.dataset.showLoon == "true" ) {
                    this.hideLoon = false;
                } else {
                    this.hideLoon = true;
                }

                this.updateTotal();
            }
        }

        function setupJaartalDropdown () {
            const input = document.querySelectorAll('.jaartal-select');

            if ( input ) {
                input.forEach(elem => {
                    const select = elem.nextSibling;

                    changeJaartalDropdown(elem, select)();

                    select.addEventListener('change', changeJaartalDropdown(elem, select));
                });
            }
        }

        setupJaartalDropdown();
    }


    setupSidebar () {
        const fixedHeader = document.querySelector('.main-nav-holder');

        const sidebar = document.querySelector('.sidebar.show_total');
        if ( sidebar ) {
            const sidebarFixed = sidebar.cloneNode(true);

            sidebarFixed.classList.add('fixed');
            sidebarFixed.style.top = fixedHeader.offsetHeight + 'px';
            sidebarFixed.style.maxWidth = sidebar.parentNode.offsetWidth - 30 + 'px';

            sidebar.parentNode.append(sidebarFixed);


            const setFixedSidebar = () => {
               const currentOffset = sidebar.getBoundingClientRect().top - fixedHeader.offsetHeight

               if ( currentOffset > 0 ) {
                   sidebarFixed.style.display = 'none';
               } else {
                   sidebarFixed.style.display = 'block';
               }
            }


            window.addEventListener('scroll', setFixedSidebar);
            setFixedSidebar();
        }
    }

}
